var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 715,
    height: 715,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M637.49,624.436 C637.49,635.812,646.576,647.041,660.284,647.041 C671.745,647.041,683.078,638.078,683.078,624.436 C683.078,613.034,673.963,601.641,660.284,601.641 C646.604,601.641,637.49,613.032,637.49,624.436Z M645.355,624.436C645.355,614.278,650.544,608.398,660.284,608.398 C670.015,608.398,675.214,614.289,675.214,624.436 C675.214,634.591,670.022,640.468,660.284,640.468 C650.556,640.468,645.355,634.579,645.355,624.436Z M651.62,612.023V635.247H657.275V626.462H659.24 L664.154,635.247H670.419L665.199,625.847 C668.214,625.601,669.809,622.556,669.809,619.579 C669.809,615.045,667.707,612.023,659.299,612.023 H651.62ZM657.275,616.571H660.284 C661.942,616.571,663.784,617.087,663.784,619.151 C663.784,621.144,662.355,621.916,660.284,621.916 H657.275V616.571Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 10,
    stroke: "#000000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.4835,
    y: 110.4835,
    width: 494.033,
    height: 494.033,
    transform: "rotate(45 357.5 357.5)",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.5,
    cy: 357.5,
    r: 349.334
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.de6880acb30de6fc7fba831d47a5e181.svg";
export { ForwardRef as ReactComponent };